import { type FC, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Card } from "@ui/Card";
import type { StepTitle } from "@/types/Form";
import { cn } from "@/utils/tailwind";

interface StepCardProps {
  children: ReactNode;
  stepTitle: StepTitle;
  isLastStep?: boolean;
  className?: string;
}

export const StepCard: FC<StepCardProps> = ({ children, isLastStep, stepTitle, className }) => {
  const { t } = useTranslation();

  return (
    <Card
      data-test={`${stepTitle}-step-card`}
      className={cn(
        "gap-[30px] border-transparent px-[30px] py-10 md:px-8 md:py-6 xl:gap-10",
        isLastStep && "px-4 py-[18px] md:px-12 md:py-10",
        className,
      )}
    >
      <h3
        className="text-xl font-bold md:text-2xl lg:text-[34px]"
        data-test={`${stepTitle}-step-title`}
      >
        {t(`stepTitles.${stepTitle}`)}
      </h3>
      {children}
    </Card>
  );
};
